import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const servicenow: GetCustomerCopyFunc = () => {
  return {
    displaySessionLimit: false,
  }
}
